import React from 'react';
import {
  Container,
  Header,
} from './styles';
import ChatWidgetContainer from '../../../components/ChatWidget/ChatWidgetContainer';

const PendingPage: React.FC = () => {
  return (
    <Container>
      <Header>
        {/* Botão de voltar removido conforme solicitado */}
      </Header>

      <ChatWidgetContainer />
    </Container>
  );
};

export default PendingPage; 


